import Form from 'antd/es/form';
import Input from 'antd/es/input';
import React from 'react';

import type { EmbeddingsBlockConfig, PipelineBlock } from '@mai/types';

import { BooleanToggle, NumberRange } from './shared';

interface EmbeddingsBlockEditorProps {
  block: PipelineBlock & { type: 'embeddings' };
  onConfigChange: (config: EmbeddingsBlockConfig) => void;
}

export const EmbeddingsBlockEditor: React.FC<EmbeddingsBlockEditorProps> = ({
  block,
  onConfigChange,
}) => {
  const [form] = Form.useForm();

  // Initialize form with current values
  React.useEffect(() => {
    form.setFieldsValue({
      model:
        block.config.model ||
        'sentence-transformers/static-retrieval-mrl-en-v1',
      batch_size: block.config.batch_size || 100,
      normalize: block.config.normalize ?? true,
    });
  }, [block.config, form]);

  const handleValuesChange = (
    _: unknown,
    allValues: Partial<EmbeddingsBlockConfig>,
  ) => {
    onConfigChange({
      ...block.config,
      model:
        allValues.model || 'sentence-transformers/static-retrieval-mrl-en-v1',
      batch_size: allValues.batch_size || 100,
      normalize: allValues.normalize ?? true,
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      size="small"
      onValuesChange={handleValuesChange}
    >
      <Form.Item
        label="Model"
        name="model"
        help="Embedding model to use for generating embeddings"
        rules={[{ required: true, message: 'Model is required' }]}
      >
        <Input placeholder="sentence-transformers/static-retrieval-mrl-en-v1" />
      </Form.Item>

      <NumberRange
        label="Batch Size"
        name="batch_size"
        min={1}
        max={1000}
        placeholder="100"
        help="Number of texts to process in each batch"
      />

      <BooleanToggle
        label="Normalize"
        name="normalize"
        help="Normalize the generated embeddings to unit length"
        checkedChildren="Yes"
        unCheckedChildren="No"
      />
    </Form>
  );
};
